import { render } from "./message-image.vue?vue&type=template&id=4f54d72e&scoped=true&ts=true"
import script from "./message-image.vue?vue&type=script&lang=ts"
export * from "./message-image.vue?vue&type=script&lang=ts"

import "./message-image.vue?vue&type=style&index=0&id=4f54d72e&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f54d72e"]])

export default __exports__